var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBrokenlink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: 200,
    viewBox: "0 0 595 347",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M286.112 204.27L254.442 222.555L191.102 259.124L90.4032 317.263C76.0544 325.547 57.7067 320.631 49.4224 306.282L15 246.66C6.71572 232.312 11.632 213.964 25.9808 205.68L227.378 89.4028C241.727 81.1186 260.075 86.0348 268.359 100.384L285.57 130.194L301.676 158.09",
    stroke: "#949494",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M308.037 131.995L339.707 113.711L403.047 77.1414L503.746 19.003C518.094 10.7187 536.442 15.635 544.726 29.9837L579.149 89.6052C587.433 103.954 582.517 122.302 568.168 130.586L366.771 246.863C352.422 255.147 334.074 250.231 325.79 235.882L308.579 206.071L292.473 178.176",
    stroke: "#949494",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M302.137 4V64.6329",
    stroke: "#949494",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M356.707 32.8008L326.39 85.3104",
    stroke: "#949494",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M246.052 25.2227L276.368 77.7323",
    stroke: "#949494",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M302.137 343V282.367",
    stroke: "#949494",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M356.707 314.199L326.39 261.69",
    stroke: "#949494",
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M246.052 321.777L276.368 269.268",
    stroke: "#949494",
    strokeWidth: 8,
    strokeLinecap: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrokenlink);
export default __webpack_public_path__ + "static/media/brokenlink.9c9c2b05275c52ae1a3ea746c622c7c8.svg";
export { ForwardRef as ReactComponent };